"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { Toaster, toast } from "@medusajs/ui";
import { useTranslations } from "next-intl";
import ClientLink from "@modules/common/components/client-link";
export default function CookieBanner() {
  const $ = _c(8);
  const t = useTranslations("metadata");
  const [visible, setVisible] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const consent = document.cookie.split("; ").find(_temp);
      if (!consent) {
        setVisible(true);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      document.cookie = "cookie_consent=true; path=/; max-age=15552000";
      window.dispatchEvent(new CustomEvent("cookie-consent-changed", {
        detail: {
          consent: true
        }
      }));
      setVisible(false);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const acceptCookies = t2;
  let t3;
  let t4;
  if ($[3] !== t || $[4] !== visible) {
    t3 = () => {
      if (visible) {
        toast("Cookies", {
          description: <span>vangoura.com{" "}{t("uses technical cookies needed for the site to work properly")}.{" "}{t("Read our")}{" "}<ClientLink href="/cookie-policy" target="_blank" className="!text-blue">{t("Cookie Policy")}</ClientLink>.</span>,
          dismissable: false,
          action: {
            altText: `${t("Accept")} cookies`,
            onClick: () => {
              acceptCookies();
              toast.dismiss();
            },
            label: t("Accept")
          },
          duration: Infinity,
          position: "bottom-right"
        });
        return _temp2;
      }
    };
    t4 = [visible, t];
    $[3] = t;
    $[4] = visible;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <><Toaster /></>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function _temp2() {
  toast.dismiss();
}
function _temp(row) {
  return row.startsWith("cookie_consent=");
}